import React, { useState } from 'react';
import { PageHeader } from '@/components/primitives';
import { useAuth } from '@/lib/auth';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Save } from 'lucide-react';

export default function ProfilePage() {
  const { user } = useAuth();
  const [pw, setPw] = useState('');
  const changePw = async () => {
    if (pw.length < 6) return toast.error('At least 6 characters');
    try { await api.post('/auth/change-password', { new_password: pw }); setPw(''); toast.success('Password updated'); }
    catch (e) { toast.error(e?.response?.data?.detail || 'Failed'); }
  };
  return (
    <>
      <PageHeader title="Profile & Password" description="Update your own password anytime. Admins can reset any user's password from Admin → Users." />
      <div className="px-4 sm:px-6 lg:px-8 py-6 max-w-xl space-y-4">
        <Card className="p-5">
          <div className="flex items-center gap-3">
            <div className="h-12 w-12 rounded-full bg-primary/10 text-primary flex items-center justify-center font-medium">{(user?.name || 'U')[0]}</div>
            <div><p className="font-medium">{user?.name}</p><p className="text-xs text-muted-foreground">{user?.email} · <span className="capitalize">{user?.role}</span></p></div>
          </div>
        </Card>
        <Card className="p-5 space-y-3">
          <p className="font-display font-semibold">Change password</p>
          <div className="space-y-1.5"><Label>New password</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} data-testid="profile-new-password" /></div>
          <div className="flex justify-end"><Button onClick={changePw} data-testid="profile-change-password"><Save className="h-4 w-4 mr-2" />Update password</Button></div>
        </Card>
      </div>
    </>
  );
}
